/* global window, document */
'use strict';
const Cookie = require('cookie');
const Qs = require('qs');
const Xhr = require('xhr');
const UserIdentity = require('./user-identity');


const jsonFetch = function (options, callback) {

    const cookies = Cookie.parse(document.cookie);
    const config = {
        url: options.url,
        method: options.method,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    };

    if (UserIdentity._checkUserToken() !== null) {
        config.headers['X-api-key'] = UserIdentity._checkUserToken();
    }
    
    /*if (cookies.crumb) {
        config.headers['X-CSRF-Token'] = cookies.crumb;
    }*/

    if (options.query && options.method !== 'DELETE') {
        if (UserIdentity._getHostName(config.url) !== 'app.socialbicycles.com') {
            config.url += '?' + Qs.stringify(options.query);
        } 
    }

    if (options.data) {
        config.body = JSON.stringify(options.data);
    }

    if (options.method === 'DELETE') {
        config.body = JSON.stringify(options.query);
    }
    
    if (UserIdentity._getHostName(config.url) === 'feeds.transloc.com') {
        config.headers = {};
    }

    /*if (UserIdentity._getHostName(config.url) === 'app.socialbicycles.com') {
        config.headers = {};
        config.headers['Authorization'] = "Bearer "+options.query.auth;
        console.log("config", config);
    }*/

    //console.log("config", config);
    Xhr(config, (err, response, body) => {

        if (err) {
            return callback(err);
        }

        if (response.statusCode >= 200 && response.statusCode < 300) {
            body = JSON.parse(body);
            body.statusCode = response.statusCode;
            callback(null, body);
        }
        else {
            const httpErr = new Error(response.rawRequest.statusText);
            callback(httpErr, JSON.parse(body));
        }
    });
};


if (global.window) {
    window.jsonFetch = jsonFetch;
}


module.exports = jsonFetch;



// WEBPACK FOOTER //
// client/helpers/json-fetch.js